import PropTypes from 'prop-types';
import { createContext, useMemo, useState } from 'react';

import { FORM_DEFAULT_VALUES, RESULT_DEFAULT_VALUES } from './constants';

/**
 * Provider/Context components for the Lumber Decking Calculator context.
 * Where values are stored and shared across Lumber Decking Calculator components.
 */
export const LumberDeckingContext = createContext();

export const LumberDeckingProvider = ({ children }) => {
  const [calculatorValues, setCalculatorValues] = useState(FORM_DEFAULT_VALUES);
  const [result, setResult] = useState(RESULT_DEFAULT_VALUES);
  // Wrapping the context value in useMemo to prevent unnecessary re-renders
  const contextValue = useMemo(() => ({ calculatorValues, setCalculatorValues, result, setResult }), [
    calculatorValues,
    result,
  ]);

  return <LumberDeckingContext.Provider value={contextValue}>{children}</LumberDeckingContext.Provider>;
};

LumberDeckingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
